import { render, staticRenderFns } from "./ToolbarProductModels.component.vue?vue&type=template&id=a63e7928&scoped=true&"
import script from "./ToolbarProductModels.component.vue?vue&type=script&lang=js&"
export * from "./ToolbarProductModels.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63e7928",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VListItem } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VBtnToggle,VListItem})
